var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"padding":"10px 15px"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/searchlogo.png","alt":""}})])
}]

export { render, staticRenderFns }